//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './InvestigationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetInvestigationQueryParameters = {
  recipeId: number ;
}

export type CreateOrUpdateInvestigationInvestigationQueryParameters = {
  recipeId: number ;
}

export function getUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/investigation/{recipeId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.InvestigationDto, unknown, Types.InvestigationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.InvestigationDto, unknown, Types.InvestigationDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(recipeId: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId,  } = params[0] as GetInvestigationQueryParameters;

    return trimArrayEnd([
        'InvestigationClient',
        'get',
        recipeId as any,
      ]);
  } else {
    return trimArrayEnd([
        'InvestigationClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.InvestigationDto, TError = unknown>(dto: GetInvestigationQueryParameters, options?: Omit<UseQueryOptions<Types.InvestigationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets the Investigation for the User.
 * @param recipeId Id of the Recipe for get.
 * @return Dto with investigation's data.
 */
export function useGetQuery<TSelectData = Types.InvestigationDto, TError = unknown>(recipeId: number, options?: Omit<UseQueryOptions<Types.InvestigationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.InvestigationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.InvestigationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId,  } = params[0] as GetInvestigationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.InvestigationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(recipeId),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.InvestigationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets the Investigation for the User.
 * @param recipeId Id of the Recipe for get.
 * @return Dto with investigation's data.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.InvestigationDto | undefined) => Types.InvestigationDto, recipeId: number) {
  queryClient.setQueryData(getQueryKey(recipeId),
    updater
  );
}

/**
 * Gets the Investigation for the User.
 * @param recipeId Id of the Recipe for get.
 * @return Dto with investigation's data.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.InvestigationDto | undefined) => Types.InvestigationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createOrUpdateInvestigationUrl(recipeId: number): string {
  let url_ = getBaseUrl() + "/api/investigation/{recipeId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createOrUpdateInvestigationMutationKey(recipeId: number): MutationKey {
  return trimArrayEnd([
      'InvestigationClient',
      'createOrUpdateInvestigation',
      recipeId as any,
    ]);
}

/**
 * Creates a new Investigation for the User.
 * @param recipeId Id of the Recipe for get.
 * @param dto Dto with data for creation.
 * @return Dto with created Investigation
 */
export function useCreateOrUpdateInvestigationMutation<TContext>(recipeId: number, options?: Omit<UseMutationOptions<Types.InvestigationDto, unknown, Types.CreateOrUpdateInvestigationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.InvestigationDto, unknown, Types.CreateOrUpdateInvestigationDto, TContext> {
  const key = createOrUpdateInvestigationMutationKey(recipeId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateOrUpdateInvestigationDto) => Client.createOrUpdateInvestigation(recipeId, dto),
    mutationKey: key,
  });
}
  
type CreateOrUpdateInvestigation__MutationParameters = CreateOrUpdateInvestigationInvestigationQueryParameters & {
  dto: Types.CreateOrUpdateInvestigationDto;
}

/**
 * Creates a new Investigation for the User.
 * @param recipeId Id of the Recipe for get.
 * @param dto Dto with data for creation.
 * @return Dto with created Investigation
 */
export function useCreateOrUpdateInvestigationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.InvestigationDto, unknown, CreateOrUpdateInvestigation__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: CreateOrUpdateInvestigationInvestigationQueryParameters}): UseMutationResult<Types.InvestigationDto, unknown, CreateOrUpdateInvestigation__MutationParameters, TContext> {
  const key = createOrUpdateInvestigationMutationKey(options?.parameters?.recipeId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: CreateOrUpdateInvestigation__MutationParameters) => Client.createOrUpdateInvestigation(data.recipeId ?? options?.parameters?.recipeId!, data.dto),
  mutationKey: key,
});
}